<template>
  <CollapsePanel
    :title="$t('route_management.statistics')"
    :loading="loading"
    :showCount="false"
    :showCollapseAction="false"
    panelName="management.statistics"
    :borderTop="false"
  >
    <div class="statistics-block">
      <h3 class="block-header">{{ $t('statistics.actionstatistics', ) | capitalize }}</h3>
      <ul class="block-details" v-for="(action, index) in actionStatistics" :key="'action'+index">
        <li class="block-item">
          <span class="block-item-title">{{ action.name }}:</span>
          <span class="block-item-content">{{ action.amount }}</span>
          <span class="block-item-content"> {{ $t('statistics.pcs', )}}</span>
        </li>
      </ul>

      <h3 class="block-header">{{ $t('statistics.map_objectstatistics', ) | capitalize }}</h3>
      <ul
        class="block-details"
        v-for="(mapobject, index) in mapObjectStatistics"
        :key="'mapobject'+index"
      >
        <li class="block-item">
          <span class="block-item-title">{{ mapobject.name }}:</span>
          <span class="block-item-content">{{ mapobject.amount }}</span>
          <span class="block-item-content"> {{ $t('statistics.pcs', )}}</span>
          <span class="block-item-content" v-if="mapobject.length">
            ({{ mapobject.length }} km)
          </span>
          <span class="block-item-content" v-if="mapobject.area">
            ({{ mapobject.area }} km<sup>2</sup>)
          </span>
        </li>
      </ul>
    </div>
  </CollapsePanel>
</template>

<script>
import { mapGetters } from 'vuex';

import CollapsePanel from '@/components/CollapsePanel.vue';

import * as dataCache from '@/store/cache/dataCache';

export default {
  name: 'Statistics',
  components: {
    CollapsePanel,
  },
  data() {
    return {
      map_object_statistics: [],
      action_statistics: [],
      actionStatistics: [],
      mapObjectStatistics: [],
      loading: true,
    };
  },
  computed: {
    ...mapGetters({
      network: 'settings/getNetworkModel',
      dynamicActionTypes: 'settings/getDynamicActionTypes',
      mapObjectTypes: 'settings/getMapObjectTypes',
    }),
  },
  mounted() {
    this.actionStatistics = dataCache.getActionStatistics(this.dynamicActionTypes);
    this.mapObjectStatistics = dataCache.getMapObjectStatistics(this.mapObjectTypes);
    this.loading = false;
  },
};
</script>
<style scoped>
.statistics-block {
  padding: 0 20px;
}

.statistics-block h3.block-header {
  text-transform: uppercase;
  font-style: normal;
  font-weight: 400;
  font-size: 1em;
  margin: 30px 0 5px 0;
  padding: 0;
  color: #42464c;
}

.statistics-block ul.block-details {
  overflow: auto;
  zoom: 1;
  font-size: 0.85em;
  margin: 0 0 0px 0;
  padding: 0;
}

.statistics-block ul.block-details li.block-item {
  line-height: 1.7em;
  position: relative;
  clear: both;
  list-style: none;
}

.statistics-block .block-details .block-item .block-item-title {
  display: block;
  float: left;
  width: 60%;
}
</style>
